export default {
  // Form - unique texts
  minutesPerPedagogicalHour: 'Minutes per Pedagogical Hour',

  // Messages - unique texts
  deleteConfirmTitle: 'Are you sure you want to delete the Graduation Profile Type?',
  deletedMessage: 'Graduation Profile Type deleted.',
  cannotDeleteWithEntity: 'Cannot delete {entity1} if it has {entity2}',
}
